import { render, staticRenderFns } from "./OnlineResearchResult.vue?vue&type=template&id=14ccec28&scoped=true&"
import script from "./OnlineResearchResult.vue?vue&type=script&lang=js&"
export * from "./OnlineResearchResult.vue?vue&type=script&lang=js&"
import style0 from "./OnlineResearchResult.vue?vue&type=style&index=0&id=14ccec28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ccec28",
  null
  
)

export default component.exports